export default [
  {
    name: 'Broken',
    value: 'BROKEN',
  },
  {
    name: 'Spare',
    value: 'SPARE',
  },
  {
    name: 'Maintenance',
    value: 'MAINTENANCE',
  },
];
